import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "HelperMixin",
  data() {
    return {
      a: "",
    };
  },
  computed: {
    ...mapGetters(["baseUrl", "appToken"]),
  },
  methods: {
    async helperGet(action, param = {}) {
      const link = `${this.baseUrl}/${action}?${this.helperSerialize(param)}`;
      console.log("link", link);
      try {
        const response = await axios.get(link);
        console.log(response);
        return response;
      } catch (error) {
        this.$toast.error("خطای شبکه رخ داده");
      }
    },

    async helperPost(action, param = {}) {
      const link = `${this.baseUrl}/${action}?${this.helperSerialize(param)}`;
      try {
        const response = await axios.post(link, param, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.appToken}`,
          },
        });
        return response;
      } catch (error) {
        this.$toast.error("خطای شبکه رخ داده");
      }
    },

    async helperSetting() {
      const response = await this.helperGet("setting");
      return response?.data?.result === "1" ? response.data.data : {};
    },

    helperSerialize(obj) {
      obj.token = this.appToken;
      return Object.keys(obj)
          .map(
              (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
          )
          .join("&");
    },

    helperExcerpt(str, len) {
      if (typeof str !== "string") {
        return str;
      }
      return str.length > len ? `${str.substring(0, len)}...` : str;
    },

    helperNumberFormat(number) {
      number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
      const n = !isFinite(+number) ? 0 : +number;
      const prec = 0;
      const sep = ",";
      const dec = ".";
      const toFixedFix = (n, prec) => {
        const k = Math.pow(10, prec);
        return (Math.round(n * k) / k).toFixed(prec);
      };
      let s = (prec ? toFixedFix(n, prec) : Math.round(n).toString()).split(
          "."
      );
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
      }
      return s.join(dec);
    },
  },
};
